export const LOADING_MESSAGE = 'Loading';
export const DOCUMENT_DAMAGE_PROVIDER_NAME = 'Plnar';
export const DEFAULT_BANNER_ERROR_MESSAGE =
  'Something went wrong. Please reload the page or contact us for assistance.';
export const DEFAULT_BANNER_ERROR_MESSAGE_WITHOUT_CALL_US = 'Something went wrong, please reload the page.';
export const CALL_US_ERROR_MESSAGE = 'Something went wrong, please give us a call.';
export const CLAIMS_RETRIEVAL_ISSUE_MESSAGE =
  'We’re currently having trouble retrieving claim history. If your claim does not appear below, please try again later.';
export const DEFAULT_DISTANCE = '25';
export const DEFAULT_ZOOM = 9;
export const DEFAULT_LIST_SIZE_PER_PAGE = 5;
export const hiddenClaimsText = 'Need to see an older claim? Contact us for claims older than 10 years.';
export const MULTIPLE_VEHICLES_TEXT = 'Multiple Vehicles';
export const contactUsToFileClaimText = 'If you need to file a claim, please contact us.';
export const noValidPoliciesContactUsText = 'To check on an existing claim or start a new claim, please contact us.';
export const noVehiclesFoundText = 'No vehicles found for this claim.';
// Converse errorCode for a draft that has already been submitted as a full claim (E1PCDC-7008)
export const CONVERSE_DRAFT_ALREADY_SUBMITTED_CODE = '400008';

// Buttons
export const addAnotherPersonBtn = 'Add another person';
export const backBtn = 'Back';
export const cancelBtn = 'Cancel';
export const completeTasksBtn = 'Complete tasks';
export const confirmReservationBtn = 'Confirm reservation';
export const continueBtn = 'Continue';
export const continueWithNewClaimBtn = 'Continue with new claim';
export const deleteBtn = 'Delete';
export const deleteThisContactBtn = 'Delete this contact';
export const fileAClaimBtn = 'File a claim';
export const findAPartnerRepairShopBtn = 'Find a partner repair shop';
export const goToClaimsBtn = 'Go to claims';
export const goToDocumentDamageBtn = 'Go to document damage';
export const goToEmergencyServices = 'Go to emergency services';
export const goToWaterRemovalBtn = 'Go to water removal';
export const makeRentalReservationBtn = 'Make rental reservation';
export const reloadPageBtn = 'Reload page';
export const resumeBtn = 'Resume';
export const selectBtn = 'Select';
export const selectThisPartnerBtn = 'Select this partner';
export const sendLinkBtn = 'Send link';
export const setUpServicesBtn = 'Set up services';
export const skipBtn = 'Skip';
export const skipPhotosBtn = 'Skip photos';
export const skipRepairShopBtn = 'Skip repair shop';
export const submitClaimBtn = 'Submit claim';
export const uploadPhotosBtn = 'Upload photos';
export const viewDetailsBtn = 'View details';
export const yesSelectThisLocationBtn = 'Yes, select this location';
export enum ClaimServicesConstants {
  DRP = 'drp',
  RENTAL = 'RENTAL',
  CVP = 'cvp',
}

export enum DamageConstants {
  NO_DAMAGE = 'No damage to vehicle',
  SOME_DAMAGE = 'Some damage to vehicle',
  ALL_DAMAGE = 'Damage all over vehicle',
}

export const emailValidatedRegex = /^((?!([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+).)*$/i;

export enum FNOLCancelConfirmationConstants {
  TITLE = 'Are you sure you want to cancel this claim?',
  DESCRIPTION = "If you cancel this claim, everything you've entered will be lost and no claim will be created.",
  PRIMARY_BUTTON_TEXT = 'Yes, cancel this claim',
  SECONDARY_BUTTON_TEXT = 'No, continue this claim',
  CONTACT_INFO_DELETE_DESCRIPTION = 'If you want to remove this contact information from your claim, choose Delete.',
}

export enum DeleteConfirmationConstants {
  PRIMARY_BUTTON_TEXT = 'Delete',
  SECONDARY_BUTTON_TEXT = 'Cancel',
}

export enum DRPConfirmationConstants {
  TITLE = 'A Quick Reminder About Repairs',
  DESCRIPTION = "If you cancel this claim, everything you've entered will be lost and no claim will be created.",
  PRIMARY_BUTTON_TEXT = 'Okay',
  SECONDARY_BUTTON_TEXT = 'Cancel',
}

export const GenericModalTopMargin = '23%';

export enum CallingSubcontexts {
  RISK_SELECTION = 'risk-selection',
  CLAIM_DETAIL = 'claim-detail',
  CLAIMS_OVERVIEW = 'claims-overview',
}

export const RentalServicesText = {
  headerNoRentalCoverage: 'Rental Vehicle Information',
  headerWithCoverage: 'Good news - you have rental vehicle coverage!',

  rentalFullyEligibleAccordionText:
    'Good news - you have rental vehicle coverage! We partner with Enterprise Rent-A-Car, but you’re welcome to use any rental company you prefer. To make a reservation with Enterprise Rent-A-Car please click on the Complete tasks button at the top of your screen. To choose a different rental company, please contact us.',
  subHeaderWithFullCoverage: 'Would you like to set up a reservation?',
  coveragePrefix: "You're covered for a ",

  bodyRentalEligiblePartner:
    "We partner with Enterprise Rent-A-Car, but you're welcome to use any rental company you prefer. If you'd like to use a different company, please contact us.",
  bodyRentalEligibleReserve:
    "Select Make Rental Reservation to reserve a vehicle. From there, you'll choose where you'll pick up your rental vehicle. Then, Enterprise will call you to finalize the reservation.",
  bodyRentalEligibleReserveLater: 'Want to reserve a vehicle later? You can do so from the Claims tab.',
  bodyRentalEligibleReserveBold: 'Make Rental Reservation',
  bodyRentalEligibleLaterBold: 'Claims',

  bodyRentalEligibleContactToConfirm:
    'You may be eligible for rental vehicle coverage as part of your policy. We partner with Enterprise Rent-A-Car, but you’re welcome to use any rental company you prefer. To confirm your eligibility and learn about your next steps, please contact us before making any rental arrangements.',

  bodyRentalNotCoveredContactToReserve:
    'To reserve a rental vehicle through our partners at Enterprise Rent-A-Car and take advantage of our discount, please contact us for assistance. You can also choose any other car rental company you like. If you want to use a different company, please let us know.',
} as const;
